import styled from "styled-components";

const ButtonFormContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default ButtonFormContainer;
